import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
// import type { IFilter } from "@/interface/common.interface";
import type {
  ILeaveSetting,
  ILeaveSettingResponse,
  ILeaveSettingByIdResponse,
  ILeave,
  ILeaveResponse,
  ILeaveByIdResponse,
} from "@/interface/leave";

export const LeaveService = {
  createLeaveSetting: async (
    payload: ILeaveSetting,
  ): Promise<ILeaveSettingResponse> => {
    const API = `${API_ENDPOINT.leave}/settings`;
    return callApi<ILeaveSettingResponse>(API, {
      method: "POST",
      data: payload,
    });
  },

  getLeaveSettings: async (params?: string): Promise<ILeaveSettingResponse> => {
    const API = `${API_ENDPOINT.leave}/settings${params ? `?${params}` : ""}`;
    return callApi<ILeaveSettingResponse>(API, { method: "GET" });
  },

  updateLeaveSetting: async (
    payload: ILeaveSetting,
    id: string,
  ): Promise<ILeaveSettingResponse> => {
    if (!id) throw new Error("ID is required to update leave setting");
    const API = `${API_ENDPOINT.leave}/settings/${id}`;
    return callApi<ILeaveSettingResponse>(API, {
      method: "PUT",
      data: payload,
    });
  },

  deleteLeaveSetting: async (id: string): Promise<ILeaveSettingResponse> => {
    if (!id) throw new Error("ID is required to delete leave setting");
    const API = `${API_ENDPOINT.leave}/settings/${id}`;
    return callApi<ILeaveSettingResponse>(API, { method: "DELETE" });
  },

  getLeaveSettingById: async (
    id: string,
  ): Promise<ILeaveSettingByIdResponse> => {
    if (!id) throw new Error("ID is required to get leave setting details");
    const API = `${API_ENDPOINT.leave}/settings/${id}`;
    return callApi<ILeaveSettingByIdResponse>(API, { method: "GET" });
  },

  // Applied Leaves
  createLeave: async (payload: ILeave): Promise<ILeaveResponse> => {
    const API = `${API_ENDPOINT.leave}`;
    return callApi<ILeaveResponse>(API, { method: "POST", data: payload });
  },

  getLeaves: async (params?: string): Promise<ILeaveResponse> => {
    const API = params ? `${API_ENDPOINT.leave}?${params}` : `${API_ENDPOINT.leave}`;
    return callApi<ILeaveResponse>(API, { method: "GET" });
  },

  getLeaveById: async (id: string): Promise<ILeaveByIdResponse> => {
    if (!id) throw new Error("ID is required to get leave details");
    const API = `${API_ENDPOINT.leave}/${id}`;
    return callApi<ILeaveByIdResponse>(API, { method: "GET" });
  },

  updateLeave: async (payload: ILeave, id: string): Promise<ILeaveResponse> => {
    if (!id) throw new Error("ID is required to update leave");
    const API = `${API_ENDPOINT.leave}/${id}`;
    return callApi<ILeaveResponse>(API, { method: "PUT", data: payload });
  },

  deleteLeave: async (id: string): Promise<any> => {
    if (!id) throw new Error("ID is required to delete leave");
    const API = `${API_ENDPOINT.leave}/${id}`;
    return callApi<any>(API, { method: "DELETE" });
  },

  updateLeaveStatus: async (
    id: string,
    payload: { status: string; remarks: string; userId?: string }
  ): Promise<any> => {
    if (!id) throw new Error("ID is required to update leave status");
    const API = `${API_ENDPOINT.leave}/${id}/status`;
    return callApi<any>(API, { method: "PUT", data: payload });
  },
};
